// Seedable mulberry32 PRNG, in pure functional style: each draw returns the
// value plus the advanced state, so callers thread RngState explicitly and the
// whole simulation stays a pure function of (state, input).

import type { RngState } from '../state/types';

export const makeSeed = (seed: number): RngState => ({ s: seed >>> 0 });

export interface RngDraw {
  readonly value: number; // in [0, 1)
  readonly state: RngState;
}

export const next = (state: RngState): RngDraw => {
  const t = (state.s + 0x6d2b79f5) >>> 0;
  let r = t;
  r = Math.imul(r ^ (r >>> 15), r | 1);
  r ^= r + Math.imul(r ^ (r >>> 7), r | 61);
  const value = ((r ^ (r >>> 14)) >>> 0) / 4294967296;
  return { value, state: { s: t } };
};

export interface RngIntDraw {
  readonly value: number;
  readonly state: RngState;
}

/** Integer in [min, max) (min inclusive, max exclusive). */
export const intInRange = (
  state: RngState,
  min: number,
  max: number,
): RngIntDraw => {
  const draw = next(state);
  return { value: min + Math.floor(draw.value * (max - min)), state: draw.state };
};

/** Float in [min, max). */
export const floatInRange = (
  state: RngState,
  min: number,
  max: number,
): RngDraw => {
  const draw = next(state);
  return { value: min + draw.value * (max - min), state: draw.state };
};
